import { render, staticRenderFns } from "./OrdenVentaList.vue?vue&type=template&id=19d81d54&scoped=true&"
import script from "./OrdenVentaList.vue?vue&type=script&lang=js&"
export * from "./OrdenVentaList.vue?vue&type=script&lang=js&"
import style0 from "./OrdenVentaList.vue?vue&type=style&index=0&id=19d81d54&scoped=true&lang=css&"
import style1 from "./OrdenVentaList.vue?vue&type=style&index=1&lang=css&"
import style2 from "./OrdenVentaList.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d81d54",
  null
  
)

export default component.exports